import { Sys } from 'libs/contentful/types';
import Image from 'next/image';
import { NotificationOverlayDesktopPosition } from 'types/constants';
import { cn } from 'utils/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';

interface NotificationOverlayProps {
  sys?: Sys;
  description?: string;
  fileName?: string;
  url: string;
  notificationOverlayDesktopPosition?: NotificationOverlayDesktopPosition;
}

export const topClass = 'sm:top-20';
export const bottomClass = 'sm:bottom-20';
export const leftClass = 'sm:left-[-45px]';
export const rightClass = 'sm:right-[-45px]';
export const middleClass = 'sm:top-1/2 sm:-translate-y-1/2';

export const setOverlayPosition = (
  notificationOverlayDesktopPosition: NotificationOverlayDesktopPosition | undefined,
): string => {
  switch (notificationOverlayDesktopPosition) {
    case NotificationOverlayDesktopPosition.BottomLeft:
      return `${bottomClass} ${leftClass}`;
    case NotificationOverlayDesktopPosition.MiddleLeft:
      return `${middleClass} ${leftClass}`;
    case NotificationOverlayDesktopPosition.TopLeft:
      return `${topClass} ${leftClass}`;
    case NotificationOverlayDesktopPosition.BottomRight:
      return `${bottomClass} ${rightClass}`;
    case NotificationOverlayDesktopPosition.MiddleRight:
      return `${middleClass} ${rightClass}`;
    case NotificationOverlayDesktopPosition.TopRight:
    default:
      return `${topClass} ${rightClass}`;
  }
};

const NotificationOverlay = ({
  sys,
  description,
  url,
  notificationOverlayDesktopPosition,
}: NotificationOverlayProps) => {
  return (
    <div
      className={cn(
        setOverlayPosition(notificationOverlayDesktopPosition),
        `notification-overlay-container flex flex-row absolute z-10 justify-center`,
        'max-sm:mx-4 max-sm:left-0 max-sm:right-0 max-sm:bottom-0 max-sm:translate-y-1/2', // Center notification over the bottom of the image on mobile
      )}>
      <div {...liveUpdateAttrs(sys?.id, 'image')}>
        <Image src={url} alt={description || ''} width={406} height={127} />
      </div>
    </div>
  );
};

export default NotificationOverlay;
